import {
    FETCH_AUTHORIZATION_TOKEN_BEGIN,
    FETCH_AUTHORIZATION_TOKEN_FAILURE,
    FETCH_AUTHORIZATION_TOKEN_SUCCESS,
} from '../constants/authorization';

const initialState = {
    token: '',
    role: '',
    attribute: '',
    isLoading: false,
    error: "",
    isEditable:false,
    landingPage:null
 
}

export const getAuthorizationTokenReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_AUTHORIZATION_TOKEN_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }

        case FETCH_AUTHORIZATION_TOKEN_SUCCESS:
            return {
                ...initialState,
                isLoading: false,
                token: payload.TokenData.token,
                role: payload.TokenData.role,
                attribute: payload.TokenData.attribute,
                isEditable:payload.TokenData.isEditable,
                landingPage:payload.TokenData.defaultpage
            };
        case FETCH_AUTHORIZATION_TOKEN_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
    
        default:
            return state;
    }
}

export default getAuthorizationTokenReducer
